import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'
import config from "../../../config/config";
import axios from 'axios';
import { grid_spacing } from '../../CSS/Styles'
import {font} from '../../CSS/font'
import {grid} from '../../CSS/grid'
let styles = {...font,...grid}

class VendorDetail extends React.Component {

	constructor(props) {
		super(props);
    }



    render(){
    	const { classes } = this.props;
    	console.log(this.props.data)


    	let vendor_detail_list = [
    		{
    			icon:"fa-home",
    			data:{
    				Address: this.props.data.address,
    				Country: this.props.data.data.country,
    				State: this.props.data.data.state,
    				City: this.props.data.data.city,
    				"Postal Code": this.props.data.data.postal_code
    			}
    		},
    		{
    			icon:"fa-phone",
    			data:{
    				Tel:this.props.data.telphone
    			}
    		},
    		{
    			icon:"fa-tag",
    			data:{
    				"Vendor ID": this.props.data.data.vendor_id
    			}
    		},
    		{
    			icon:"fa-envelope",
    			data:{
    				Email: this.props.data.email
    			}
    		},
    		{
    			icon:"fa-fingerprint",
    			data:{
    				"UEN No": this.props.data.data.company_code
    			}
    		},
    		{
    			icon:"fa-user-tag",
    			data:{
    				"Name of director": null,
    				"Director's contact": null
    			}
    		},
    		{
    			icon:"fa-lock",
    			data:{
    				"Bank key": null,
    				"Bank Account No": null
    			}
    		},
    		{
    			icon:"fa-edit",
    			data:{
    				"Created by": this.props.data.data.created_by,
    				"Approved by": null
    			}
    		},
    		{
    			icon:"fa-calendar",
    			data:{
    				"Created date": this.props.data.data.created_datetime,
    				"Approved date": null
    			}
    		},

    	]



    	return(
    		<Card className={classes.card_vendor_info}>
    			<CardContent>
    				<Grid container spaceing={grid_spacing} justify="flex-start">
    					{vendor_detail_list.map((dataitem)=>{
    						console.log(dataitem)
    						return(
    							<Grid item lg={6} className={classes.content}>
    					    		<Grid container spaceing={grid_spacing}>
    					    			<Grid item lg={3}>
    					    				<i class={"fas " + dataitem.icon +" fa-2x"}/>
    					    			</Grid>
    					    			<Grid item lg={9}>
	    					    			{Object.keys(dataitem.data).map((keys)=>{
	    					    				console.log(dataitem.data[keys])
	    					    				return(
	    					    					<Typography className = {classes.card_content_text} align="left" style={{display:"block"}}>
	    					    						{dataitem.data[keys] == null ? keys + " : " + ' ' : keys + " : " + dataitem.data[keys]}
	    					    					</Typography>
	    					    				)
	    					    			})}
    					    			</Grid>
    					    		</Grid>
    							</Grid>
    						)
    					})}
    				</Grid>
    			</CardContent>
    		</Card>

    	)
    }
}

export default withStyles(styles)(VendorDetail)


// WEBPACK FOOTER //
// ./src/components/Entities/vendor/VendorDetail.js